import { useState } from 'react'
import { CloseIcon } from '../../../assets/icons/Svg'
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import {  selectCurrentProduct } from '../../../features/product/productSlice';
import { addItem, selectCurrentPackage } from '../../../features/package/packageSlice';
import { ProductPackage } from '../../../types/package';

interface ProductDetails {
    productID: number;
    productName: string;
    description: string;
    price: number;
    size: string;
    image: string;
    isAvailable: boolean;
    categoryName: string;
    qty: number
}

export default function AddQtyModal() {

    const dispatch = useDispatch();
    const product = useSelector(selectCurrentProduct);
    const currentPackage = useSelector(selectCurrentPackage);

    const [productDetails, setProductDetails] = useState<ProductDetails>({
        productID: product?.productID || 0,
        productName: product?.productName || "",
        description: product?.description || "",
        price: product?.price || 0,
        size: product?.sizeInfo.size || "",
        image: product?.image || "",
        isAvailable: product?.isAvailable || false,
        categoryName: product?.categoryInfo.categoryName || "",
        qty: 1,
    });

    const handleAddToPackageItem = () => {

        const newTotal = currentPackage.packageTotalPrice + (productDetails.price * productDetails.qty);

        if (newTotal > currentPackage.packageBudget) {
            alert("Exceeding budget");
            return;
        }

        const productData: ProductPackage = { 
            productId: productDetails.productID,
            productName: productDetails.productName,
            productCategory: productDetails.categoryName,
            productSize: productDetails.size,
            productPrice: productDetails.price,
            addons: [],
            // productQty: productDetails.qty,
        };

        dispatch(addItem(productData));
        dispatch(clearTypeOfAdditionalModal());
        // dispatch(clearSelectedProduct());
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[101]'>
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[25%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    Input Qty
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => {
                                        dispatch(clearTypeOfAdditionalModal());
                                        // dispatch(clearSelectedProduct());
                                    }}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='space-y-1'>
                                <div className="w-[50%] flex items-center mx-auto">
                                    <img 
                                        // src={cheeseburgerImg} 
                                        className="w-full h-auto object-cover rounded-lg" 
                                        alt=''
                                    />
                                </div>
                                <div className='space-y-0'>
                                    <p className="text-base font-semibold text-gray-800 leading-tight">
                                        {product?.productName}
                                    </p>
                                    <p className='text-sm text-orange-700'>
                                        {product?.categoryInfo.categoryName}
                                    </p>
                                    <button
                                        className={`border py-1 px-1.5 text-sm rounded cursor-pointer select-none transition-all border-orange-500 bg-orange-100 font-medium `}
                                    >
                                        {product?.sizeInfo.size}
                                    </button>
                                </div>
                            </div>

                        
                            <hr className="h-px bg-gray-200 border-0" />
                            <div className='w-full flex justify-between space-x-2'>
                                <div className="w-1/2 flex justify-between items-center gap-2 border border-orange-500 bg-gray-100 rounded-md p-1">
                                    <button 
                                        onClick={() => setProductDetails(prev => ({
                                            ...prev,
                                            qty: prev.qty > 1 ? prev.qty - 1 : 1, 
                                        }))}
                                        className="w-10 h-6 flex items-center justify-center text-orange-600 hover:bg-white rounded-md transition-all"
                                    >
                                        -
                                    </button>
                                    <input
                                        type="number"
                                        className="w-16 text-center font-bold text-gray-900 bg-gray-100 outline-none"
                                        value={productDetails.qty}
                                        min={1}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            setProductDetails(prev => ({
                                            ...prev,
                                            qty: isNaN(value) || value < 1 ? 1 : value, 
                                            }));
                                        }}
                                    />
                                    <button 
                                        onClick={() => setProductDetails(prev => ({
                                            ...prev,
                                            qty: prev.qty + 1,
                                        }))}
                                        className="w-10 h-6 flex items-center justify-center text-orange-600 hover:bg-white rounded-md transition-all"
                                    >
                                        +
                                    </button>
                                </div>
                                <button
                                    onClick={handleAddToPackageItem}
                                    className='w-1/2 bg-orange-500 text-white text-sm px-1.5 py-2.5 rounded-lg hover:bg-orange-600 transition'
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}